export default __webpack_public_path__ + "assets/cbArticleCNNthumb.406d4dc5.png";